import axios from "axios";
import $ from "jquery";

const state = {
  thingstodoAll: {},
  thingstodoPost: {},
  publishedThingstodoPosts: [],
  unpublishedThingstodoPosts: [],
};

const getters = {
  thingstodoAll(state) {
    return state.thingstodoAll;
  },

  thingstodoPost(state) {
    return state.thingstodoPost;
  },

  publishedThingstodoPosts(state) {
    return state.publishedThingstodoPosts;
  },

  unpublishedThingstodoPosts(state) {
    return state.unpublishedThingstodoPosts;
  },
};

const mutations = {
  setThingstodoAll(state, data) {
    state.thingstodoAll = data;
  },

  setThingstodoPost(state, post) {
    state.thingstodoPost = post;
  },

  setPublishedThingstodoPosts(state, posts) {
    state.publishedThingstodoPosts = posts;
  },

  setUnpublishedThingstodoPosts(state, posts) {
    state.unpublishedThingstodoPosts = posts;
  },

  deletePublishedThingstodoPost(state, id) {
    let index = state.publishedThingstodoPosts.findIndex((p) => p.id == id);
    state.publishedThingstodoPosts.splice(index, 1);
  },

  deleteUnpublishedThingstodoPost(state, id) {
    let index = state.unpublishedThingstodoPosts.findIndex((p) => p.id == id);
    state.unpublishedThingstodoPosts.splice(index, 1);
  },
};

const actions = {
  async fetchThingstodoAll({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/things-do-page/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setThingstodoAll", res.data);
      });
  },

  async fetchThingstodoPost({ commit, rootState }, id) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/things-do-page/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setThingstodoPost", res.data);
      });
  },

  async fetchPublishedThingstodoPosts({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/things-do-page/published`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setPublishedThingstodoPosts", res.data);
      });
  },

  async fetchUnpublishedThingstodoPosts({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/things-do-page/unpublished`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setUnpublishedThingstodoPosts", res.data);
      });
  },

  async publishThingstodoPost({ commit, dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/things-do-page/publish/update?id=${data.id}&publish=${data.publish}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        dispatch("hideSpinnerLoading", null, { root: true });

        if (data.publish) {
          $.alert("post published successfull");
          commit("deleteUnpublishedThingstodoPost", data.id);
        } else {
          $.alert("post unpublished successfull");
          commit("deletePublishedThingstodoPost", data.id);
        }
      });
  },

  async createThingstodoPost({ rootState }, post) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/things-do-page/create`, post, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updateThingstodoPost({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/things-do-page/update/${data.id}`, data.post, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async deleteThingstodoPost({ dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/things-do-page/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("post deleted successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async uploadThingsdoPhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    return await axios.post(`${apiUrl}/things-do/photo/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  async deleteThingsdoPhoto({ rootState }, data) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    await axios
      .delete(`${apiUrl}/things-do/photo/delete`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: data
      })
      .then(() => {
        $.alert("Image deleted !");
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
